import { useInfiniteQuery } from 'react-query';

import { InfiniteQueryFunction, useRequest } from '@frontend/api';

import type {
  SearchPartsCompatibleWithErpPartData,
  SearchPartsCompatibleWithErpPartQueryKey,
  SearchPartsCompatibleWithErpPartParams,
} from './types';
import { getSearchPartsCompatibleWithErpPartQueryKey } from './util';

export const useSearchPartsCompatibleWithErpPart: InfiniteQueryFunction<
  SearchPartsCompatibleWithErpPartData,
  [SearchPartsCompatibleWithErpPartParams],
  SearchPartsCompatibleWithErpPartQueryKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useInfiniteQuery({
    ...queryOptions,
    queryKey: getSearchPartsCompatibleWithErpPartQueryKey(params),
    queryFn: ({ signal }) => {
      return request<SearchPartsCompatibleWithErpPartData>(
        '/erp_stores/compatible_parts',
        {
          init: {
            signal,
          },
          query: {
            partNumber: params.partNumber,
            revision: params.revision,
            headerErpCode: params.headerErpCode,
            headerType: params.headerType,
          },
        },
      );
    },
  });
};
